import React from "react";
import { useNavigate } from "react-router-dom"; // ✅ Import this

const SubscriptionModal = ({ show, onClose, onSubscribe }) => {
  const navigate = useNavigate(); // ✅ Hook to navigate

  if (!show) return null;

  const handleMaybeLater = () => {
    onClose();            // Close modal
    navigate("/homepage");    // Navigate to home
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      backdropFilter: 'blur(6px)',
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      zIndex: 9999,
      animation: 'fadeIn 0.3s ease-in-out'
    }}>
      <div style={{
        backgroundColor: '#fff',
        padding: '45px 35px',
        borderRadius: '20px',
        boxShadow: '0 0 25px rgba(255, 64, 129, 0.35)',
        textAlign: 'center',
        maxWidth: '480px',
        width: '90%',
        fontFamily: `'Segoe UI', sans-serif`,
        position: 'relative',
        animation: 'slideIn 0.4s ease-out'
      }}>
        <h2 style={{
          marginBottom: '16px',
          color: '#e91e63',
          fontSize: '24px'
        }}>
          💖 Subscribe to Unlock Love
        </h2>

        <p style={{
          color: '#333',
          fontSize: '15px',
          lineHeight: '1.7',
          marginBottom: '10px'
        }}>
          You’ve reached your profile view limit on <span style={{
            color: '#d500f9',
            fontWeight: 'bold',
            textShadow: '0 0 4px rgba(213, 0, 249, 0.3)'
          }}>Varankal Matrimony</span>.
        </p>

        <p style={{
          color: '#666',
          fontSize: '14px',
          marginBottom: '25px'
        }}>
          Unlock full access to explore more profiles, send messages, and find your perfect match today.
        </p>

        <button onClick={onSubscribe} style={{
          padding: '12px 30px',
          background: 'linear-gradient(to right, #ff4b2b, #ff416c)',
          color: '#fff',
          border: 'none',
          borderRadius: '10px',
          fontWeight: 600,
          fontSize: '15px',
          cursor: 'pointer',
          boxShadow: '0 6px 16px rgba(255, 75, 43, 0.3)',
          transition: 'transform 0.2s ease'
        }}
          onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
          onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
        >
          View Subscription Plans
        </button>

        <br />

        <button onClick={handleMaybeLater} style={{
          marginTop: '18px',
          background: 'none',
          border: 'none',
          color: '#888',
          fontSize: '14px',
          textDecoration: 'underline',
          cursor: 'pointer'
        }}>
          Maybe Later
        </button>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; } to { opacity: 1; }
        }
        @keyframes slideIn {
          from { transform: translateY(-20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default SubscriptionModal;
